import { h } from 'preact'
import styles from './header.module.css'

export const Header = ({ text }) => (
  <h3 className={styles.header} dangerouslySetInnerHTML={{ __html: text }}></h3>
)
